import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'src/app/services/api.service';
import { AuthGuard, AuthService, Profile } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { EnumToKeyPipe } from 'src/app/services/wording-enum-pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { MessageResponse } from '../../services/dtos';

type ValidationError = 'emptyField' | 'noRoles';

@Component({
	templateUrl: './message-summary-page.component.html',
	styleUrls: ['./message-summary-page.component.scss'],
	providers: [ConfirmationService, NotificationService, TranslatePipe, EnumToKeyPipe],
})
export class MessageSummaryPageComponent implements OnInit {
	errorEmailType: ValidationError | null = null;
	errorRoleType: ValidationError | null = null;

	messages: MessageResponse[];
	profile: Profile;

	selectedMessageId?: string | 'new';
	messageRoleList: string[];

	constructor(
		private apiService: ApiService,
		private authGuard: AuthGuard,
		private authService: AuthService,
		private router: Router,
	) {}

	ngOnInit() {
		this.authService.loadUserProfile().then((profile: Profile) => {
			this.profile = profile;
		});
		this.updateMessages();
	}

	updateMessages() {
		this.apiService.messages_list().subscribe((response) => {
			this.messages = response.messages;
		});
	}

	onSelection(message: MessageResponse) {
		this.selectedMessageId = message.messageId;
	}

	restartSelection() {
		this.selectedMessageId = undefined;
	}

	openCreationMessagePage() {
		this.selectedMessageId = 'new';
	}
}
